/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2023-05-29 15:30:19
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2022 Magina Corporation. All rights reserved.
 */
import { get, post } from 'src/api/http';
import * as types from './type';
import { ReturnTableData } from 'src/api/types';

class MeterKeyMgnt {
    getBatchNo (params?: types.GetBatchParams): Promise<string[]> {
        return get('/key-management/batchNo', params);
    }
    getImportProgress (fileId:string) {
        return get('/key-management/import-progress', {fileId});
    }
    importMeterKey (fileId: string) {
        return post('/key-management/import-meter-key', {fileId});
    }
    getMeterKeyList (params:types.GetMeterKeyParams):Promise<types.MeterKeyList> {
        return get('/key-management/meter-key', params);
    }
    getKeyProgrammeList (params:types.GetKeyProgrammeParams):Promise<ReturnTableData<types.MeterKeyParams>> {
        return get('/key-management/meter-key-programme', params);
    }
    getMeterList (params:types.GetMeterParams):Promise<ReturnTableData<types.MeterRows>> {
        return get('/key-management/meters', params);
    }
    getTaskGroup (params:types.GetTaskGroupParams): Promise<types.TaskGroupRows[]> {
        return get('/key-management/task-group', params);
    }
    getTaskList (params:types.GetTaskParams) {
        return get('/key-management/task', params);
    }
    getKeyType ():Promise<types.MeterKeyTypes[]> {
        return get('/key-management/meter-key-type');
    }
    addKeyProgramme (params:any) {
        return post('/key-management/add-programme', params);
    }
    delKeyProgramme (ids:any) {
        return post('/key-management/delete-programme', ids);
    }
    createMeterKeyTask (data: types.CreateMeterKeyTask):Promise<types.CreateTaskData> {
        return post('/key-management/create-meter-key-task', data);
    }
    resetMeterKeyTask (data: types.ResetMeterKeyTask) {
        return post('/key-management/reset-task', data);
    }
}

export default new MeterKeyMgnt();
